import { render, staticRenderFns } from "./MainTabs.vue?vue&type=template&id=3cb5d050&scoped=true&"
import script from "./MainTabs.vue?vue&type=script&lang=js&"
export * from "./MainTabs.vue?vue&type=script&lang=js&"
import style0 from "./MainTabs.vue?vue&type=style&index=0&id=3cb5d050&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cb5d050",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VFlex } from 'vuetify/lib/components/VGrid';
installComponents(component, {VFlex})
